(function () {
    'use strict';

    angular
        .module('riskEventModule')
        .directive('grcRiskEvent', directive);

    directive.$inject = ['boxTmplScope', 'boxTmplHtml', 'boxTmplLinkFn'];

    function directive(boxTmplScope, boxTmplHtml, boxTmplLinkFn) {

        var directiveScope = _.clone(boxTmplScope);
        directiveScope.addRiskEvent = '&';
        directiveScope.unlinkRiskEvent = '&';
        directiveScope.layoutRatio = '=?';
        directiveScope.highlight = '=';

        return {
            scope: directiveScope,
            template: boxTmplHtml,
            controller: ['$rootScope', '$scope', '$controller',
                         function ($rootScope, $scope, $controller) {

                // Box Template
                $scope.baseTemplatePath = '/app/shared/grc/riskEvent/grcRiskEvent.[Template].tpl.html';
                // Permissions default values
                $scope.boxFeatureRole = $scope.boxFeatureRole || 'GRCRiskManagement';
                $scope.boxPermissionKey = $scope.boxPermissionKey || 'RiskEvent';

                $controller('BoxTmplController', { $scope: $scope });

                $scope.readOnly = !$scope.boxPermissions.Edit;

                // Layout
                $scope.getRiskEventColumn = function () {
                    var defaultRiskEventColumn = 'col-sm-12';

                    if (_.isUndefined($scope.layoutRatio)) return defaultRiskEventColumn;
                    if (_.isUndefined($scope.layoutRatio.riskEventColumn)) return defaultRiskEventColumn;

                    return $scope.layoutRatio.riskEventColumn;
                };

                $scope.getUnlinkColumn = function () {
                    var defaultUnlinkColumn = '';

                    if (_.isUndefined($scope.layoutRatio)) return defaultUnlinkColumn;
                    if (_.isUndefined($scope.layoutRatio.unlinkColumn)) return defaultUnlinkColumn;

                    return $scope.layoutRatio.unlinkColumn;
                };

                $scope.getBoxClass = function () {
                    var defaultBoxType = 'is-nav',
                        clickable = '';

                    if (!$scope.isBoxClickable) {
                        clickable = ' not-clickable-card';
                    }

                    if (_.isUndefined($scope.layoutRatio)) return defaultBoxType + clickable;
                    if (_.isUndefined($scope.layoutRatio.boxType)) return defaultBoxType + clickable;


                    return $scope.layoutRatio.boxType + clickable;
                };

                // Custom Information
                //// When selected risk
                //$scope.whenSelectedRisk = function (risk) {
                //    $scope.addRisk({ risk: risk });
                //}

                //// To unlink risk
                //$scope.toUnlinkRisk = function (risk, $event) {
                //    $event.stopPropagation();

                //    if (!_.isUndefined($scope.unlinkRisk)) {
                //        $scope.unlinkRisk()(risk);
                //    }
                //}

                // Page is dirty
                $scope.ctxtDir = {};
                $scope.ctxtDir.needSaveChanges = false;

                $scope.pageIsDirty = function () {
                    $scope.ctxtDir.needSaveChanges = true;
                    $rootScope.$broadcast('page-is-dirty');
                };
                $scope.pageIsNotDirty = function () {
                    $scope.ctxtDir.needSaveChanges = false;
                    $rootScope.$broadcast('page-is-not-dirty');
                };
            }],

            link: function (scope, elem, attrs) {

                boxTmplLinkFn(scope, elem, attrs);

                if (!_.isUndefined(scope.boxModel)) {
                    scope.riskLevel = scope.boxModel.RiskLevel;
                }
            }
        }
    }
})();